import React,{useState} from "react";
import {ORG_DSC_CERTIFICATE_DELETE,ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER,ORG_DSC_CERTIFICATES_FLITER_LIST, ORG_DELETE_TO_DO_ITEM ,ORG_TODO_LIST_ADDONS} from '../../../../../ApiServices/BaseURL';
import { getData, postData } from "../../../../../ApiServices/ApiService";

const ToDoListCompleteController = ( completedToDoList,completedToDoError,completedToDoLoading, onRefresh,setCompletedToDoLoading,setCompletedToDoError,setCompletedToDoList,showFilter)=>{
    const [currentPage, setCurrentPage] = useState(1);
            const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
            const [selectedDocument, setSelectedDocument] = useState(null);
              const itemsPerPage = 10;
              const[addedDate, setAddedDate] = useState('');
               const[dueDate, setDueDate] = useState('');
              const [status, setStatus] = useState("");
              const [validFrom, setValidFrom] = useState("");
              const [addedOn, setAddedOn] = useState("");
        
            const totalPages = Math.ceil(completedToDoList?.length / itemsPerPage);
          const indexOfLastItem = currentPage * itemsPerPage;
          const indexOfFirstItem = indexOfLastItem - itemsPerPage;
          const currentToDoCompletedItems = completedToDoList?.slice(indexOfFirstItem, indexOfLastItem);
        
          const handlePageChange = (pageNumber) => {
            if (pageNumber > 0 && pageNumber <= totalPages) {
              setCurrentPage(pageNumber);
            }
          };

          const handleDelete = (completedToDo, index) => {
            console.log("completedToDo ToDo",completedToDo )
            setSelectedDocument({ completedToDo, index });
            setIsDeleteModalOpen(true);
          };
        
          const handleOpenDeleteModal = () => {
            setIsDeleteModalOpen(true); // Open the modal
          };
        
          const handleCloseDeleteModal = () => {
            setIsDeleteModalOpen(false); // Close the modal
          };

          const [loading,setLoading] = useState(false);
  const [completedToDoDeleteError, setCompletedToDoDeleteError] = useState('');
  const [success, setSuccess] = useState('');
  const [completedToDoDeleteIndex, setCompletedToDoDeleteIndex] = useState(null);
  const [deletedMessages, setDeletedMessages] = useState([]);

  const handleToDoCompletedDelete = async () => {
   
    try {
      const { completedToDo, index } = selectedDocument;
      setCompletedToDoDeleteIndex(null)
      setCompletedToDoDeleteError('');  
        setSuccess('')      
        setLoading(true);
        setCompletedToDoDeleteIndex(index)
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        const payLoad = {  emp_id_auth: storedUserInfo?.emp_id, sc_id:completedToDo?.sc_id}
    
        //console.log('handleSearchEmployee payload',payLoad);
        // Make the API call
        const response = await postData(ORG_DELETE_TO_DO_ITEM,payLoad);
        const responseData = await response.json();
        //console.log('response Data',responseData);
    
        // Check for success (200) and internal status code
        if (response?.status === 200) {
          if (responseData?.statusCode === 200) {
            if (responseData?.message.toLowerCase() === 'success') {
              setCompletedToDoDeleteError('');
              setDeletedMessages((prevDeleted) => [...prevDeleted, completedToDo?.sc_id]);
                setSuccess(responseData?.info);
                setTimeout(()=>{
                  setSuccess('');
                  onRefresh();
                },3000);
                // setEmployeeList(responseData?.dataJ || []);
            } else {
              setCompletedToDoDeleteError(responseData?.info || 'Failed to delete notice board message. Please try again.');
            }
          } else {
            setCompletedToDoDeleteError(responseData?.info || 'Failed to delete notice board message. Status code error.');
          }
        } 
        // Token-related errors: 400, 401, 403
        else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
          if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
            setCompletedToDoDeleteError('Unauthorized access. Your session may have expired. Please log in again.');
            // Optionally, redirect to the login page or refresh the token
            // Example: redirectToLogin();
          } else {
            setCompletedToDoDeleteError(responseData?.info || 'Bad request. Please check the request parameters.');
          }
        } 
        // Internal Server Error: 500
        else if (response?.status === 500) {
          setCompletedToDoDeleteError(responseData?.info || 'Internal Server Error. Please try again later.');
        } 
        // Unexpected or network-related errors
        else {
          setCompletedToDoDeleteError('Unexpected error occurred. Please try again later.');
        }
      } catch (error) {
        // Handle various error scenarios
        if (error.response) {
          // Server responded with a status outside the 2xx range
          setCompletedToDoDeleteError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to delete notice board message. Please try again.'}`);
        } else if (error.request) {
          // Request was made but no response was received
          setCompletedToDoDeleteError('No response received from the server. Please check your network connection and try again.');
        } else {
          // An error occurred in setting up the request
          setCompletedToDoDeleteError(`Failed to delete notice board message. Please check your network connection and try again.`);
        }
      } finally {
        setLoading(false);
        // setCurrentNoticeDeleteIndex(null)
      }

    // onValueChange(teamData);
    // onClose();
};

const [searchUser, setSearchUser] = useState('');
const [error, setError] = useState('');
const [employeeList, setEmployeeList] = useState([]);
const [clientSearchError, setClientSearchError] = useState('');
const [employeesListLoading, setEmployeeListLoading] = useState(false)
    const handleSearchEmployee = async () => {

        try {
            setError('');
            setClientSearchError('');
            setToDoFliterError('')
            if (!searchUser) {
                setClientSearchError('Please enter valid text'); return;
            }
            setEmployeeListLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }

            //console.log('handleSearchEmployee payload', payLoad);
            // Make the API call
            const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        // setAddEmployeeError('')
                        setEmployeeList(responseData?.dataJ || []);
                        //   setError(responseData?.info);
                        setTimeout(() => {
                            // handleClose();
                            // onValueChange();
                        }, 2000);
                    } else {
                        setError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setEmployeeListLoading(false);
        }

        // onValueChange(teamData);
        // onClose();
    };

    const [searchFile, setSearchFile] = useState('');
const [fileError, setFileError] = useState('');
const [FileIdList, setFileIdList] = useState([]);
const [fileSearchError, setFileSearchError] = useState('');
const [fileListLoading, setFileListLoading] = useState(false)
    const handleSearchFile = async () => {

        try {
            setFileError('');
            setFileSearchError('');
            setToDoFliterError('')
            if (!searchFile) {
                setFileSearchError('Please enter valid text'); return;
            }
            setFileListLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "NAME-FILEID", search_word: searchFile }

            //console.log('handleSearchEmployee payload', payLoad);
            // Make the API call
            const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        // setAddEmployeeError('')
                        setFileIdList(responseData?.dataJ || []);
                        //   setError(responseData?.info);
                        setTimeout(() => {
                            // handleClose();
                            // onValueChange();
                        }, 2000);
                    } else {
                        setFileError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setFileError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setFileError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setFileError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setFileError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setFileError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setFileError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setFileError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setFileError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setFileListLoading(false);
        }

        // onValueChange(teamData);
        // onClose();
    };

    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const handleSearchInputChange = (value) => {
        setSearchUser(value);
        if (!value) {
            setSelectedEmployee(null)
        }
    }
    const handleSelectedEmployee = (employee) => {
        setSelectedEmployee(employee);
        setSearchUser(employee?.client_name);

        setEmployeeList([]); // Clear the dropdown
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const handleFileSearchInputChange = (value) => {
        setSearchFile(value);
        if (!value) {
            setSelectedFile(null)
        }
    }
    const handleSelectedFile = (employee) => {
        setSelectedFile(employee);
        setSearchFile(employee?.client_file_id);

        setFileIdList([]); // Clear the dropdown
    };
    const[toDoFilterError, setToDoFliterError] = useState('')
    const fetchCompletedToDoItemsFilterList = async () => {
        if(!selectedEmployee?.client_id && !selectedFile?.client_id && !addedDate && !dueDate){
            setToDoFliterError('Please fill at least one field to search');
            return;
          }
            try {
              setToDoFliterError('');
                setCompletedToDoLoading(true);
                setCompletedToDoError('')
                setCompletedToDoList([])
                setClientSearchError('');
                setCurrentPage(1);
                // setTeamInfo({});
                const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                const payLoad = {
                  action_type: "sc_filter",
                  emp_id_auth: storedUserInfo?.emp_id,
                  client_id: selectedEmployee?.client_id,
                  client_name: searchUser || '',
                  client_file_id: selectedFile?.client_file_id,
                  create_at: addedDate,
                  sc_time: dueDate,
                  sc_list_status: "Expired",
                }
                console.log("payLoad in Todo Filter in add ons", payLoad)
                // return
                // Make the API call
                const response = await postData(ORG_TODO_LIST_ADDONS, payLoad);
                const responseData = await response.json();
    
                // Check for success (200) and internal status code
                if (response?.status === 200) {
                    if (responseData?.statusCode === 200) {
                        if (responseData?.message.toLowerCase() === 'success') {
                            if (responseData?.dataJ?.length > 0) {
                                setCompletedToDoList(responseData?.dataJ);
                            } else {
                              setCompletedToDoError(responseData?.info || 'Data Not Found');
                            }
                        } else {
                          setCompletedToDoError(responseData?.info || 'Failed to fetch Team Information. Please try again.');
                        }
                    } else {
                      setCompletedToDoError(responseData?.info || 'Failed to fetch Team Information.');
                    }
                }
                // Token-related errors: 400, 401, 403
                else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                      setCompletedToDoError('Unauthorized access. Your session may have expired. Please log in again.');
                        // Optionally, redirect to the login page or refresh the token
                        // Example: redirectToLogin();
                    } else {
                      setCompletedToDoError(responseData?.info || 'Bad request. Please check the request parameters.');
                    }
                }
                // Internal Server Error: 500
                else if (response?.status === 500) {
                  setCompletedToDoError(responseData?.info || 'Internal Server Error. Please try again later.');
                }
                // Unexpected or network-related errors
                else {
                  setCompletedToDoError('Unexpected error occurred. Please try again later.');
                }
            } catch (error) {
                // Handle various error scenarios
                if (error.response) {
                    // Server responded with a status outside the 2xx range
                    setCompletedToDoError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Team Information. Please try again.'}`);
                } else if (error.request) {
                    // Request was made but no response was received
                    setCompletedToDoError('No response received from the server. Please check your network connection and try again.');
                } else {
                    // An error occurred in setting up the request
                    setCompletedToDoError(`Failed to fetch Team Information. Please check your network connection and try again.`);
                }
            } finally {
              setCompletedToDoLoading(false);
                showFilter();
            }
        }

        const resetFilter = ()=>{
          setSearchFile('');
          setSearchUser('');
          setAddedDate('');
          setSelectedEmployee(null);
          setDueDate('')
          setToDoFliterError('');
          setClientSearchError('');
          setError('')
          setSelectedFile('')
        }
    
          return{
            handlePageChange,
            currentToDoCompletedItems,
            currentPage,
            totalPages,

            handleCloseDeleteModal,
            handleOpenDeleteModal,
            handleDelete,
            isDeleteModalOpen,
            selectedDocument,
            setSelectedDocument,

            deletedMessages,
            completedToDoDeleteIndex,
            success,
            completedToDoDeleteError,
            loading,
            handleToDoCompletedDelete,

            clientSearchError,
        employeeList,
        error,
        employeesListLoading,
        handleSelectedEmployee,
        handleSearchInputChange,
        searchUser,
        handleSearchEmployee,
        setAddedOn,
        addedOn,
        setValidFrom,
        validFrom,
        setStatus,
        status,
        fetchCompletedToDoItemsFilterList,
        toDoFilterError,
        resetFilter,

        setDueDate,
        dueDate,
        addedDate,
        setAddedDate,

        fileListLoading,
        fileSearchError,
        FileIdList,
        fileError,
        searchFile,
        handleSearchFile,
        selectedFile,
        handleSelectedFile,
        handleFileSearchInputChange
    }

}

export default ToDoListCompleteController